
/* ARSHÉ — isolated PDP conversion interactions */
(function(){
  'use strict';

  function each(selector, fn){
    document.querySelectorAll(selector).forEach(fn);
  }

  function initNotes(root){
    var tabs=root.querySelectorAll('[data-arshe-note-tab]');
    var panels=root.querySelectorAll('[data-arshe-note-panel]');
    if(!tabs.length) return;

    tabs.forEach(function(tab){
      tab.addEventListener('click', function(){
        var key=tab.getAttribute('data-arshe-note-tab');
        tabs.forEach(function(t){
          var active=t===tab;
          t.classList.toggle('is-active',active);
          t.setAttribute('aria-selected',active?'true':'false');
        });
        panels.forEach(function(panel){
          var active=panel.getAttribute('data-arshe-note-panel')===key;
          panel.hidden=!active;
          panel.classList.toggle('is-active',active);
        });
      });
    });

    var dialog=root.querySelector('[data-arshe-notes-dialog]');
    var open=root.querySelector('[data-arshe-notes-open]');
    var close=root.querySelector('[data-arshe-notes-close]');
    if(open && dialog){
      open.addEventListener('click',function(){
        if(typeof dialog.showModal==='function') dialog.showModal();
        else dialog.setAttribute('open','');
      });
    }
    if(close && dialog){
      close.addEventListener('click',function(){
        if(typeof dialog.close==='function') dialog.close();
        else dialog.removeAttribute('open');
      });
    }
    if(dialog){
      dialog.addEventListener('click',function(e){
        if(e.target===dialog){
          if(typeof dialog.close==='function') dialog.close();
          else dialog.removeAttribute('open');
        }
      });
    }
  }

  function initNoteCopy(root){
    root.querySelectorAll('[data-arshe-note-copy]').forEach(function(button){
      button.addEventListener('click',function(){
        var text=button.getAttribute('data-note-text') || '';
        if(!text) return;
        var done=function(){
          button.classList.add('is-copied');
          setTimeout(function(){ button.classList.remove('is-copied'); },900);
        };
        if(navigator.clipboard && navigator.clipboard.writeText){
          navigator.clipboard.writeText(text).then(done).catch(function(){ done(); });
        }else{
          var area=document.createElement('textarea');
          area.value=text;
          area.setAttribute('readonly','');
          area.style.position='fixed'; area.style.opacity='0';
          document.body.appendChild(area); area.select();
          try{ document.execCommand('copy'); }catch(e){}
          document.body.removeChild(area); done();
        }
      });
    });
  }

  function initDescription(root){
    var body=root.querySelector('[data-arshe-description-body]');
    var toggle=root.querySelector('[data-arshe-description-toggle]');
    if(!body || !toggle) return;

    var text=(body.textContent||'').replace(/\s+/g,' ').trim();
    if(text.length<720) return;

    root.classList.add('is-collapsible');
    toggle.hidden=false;
    toggle.addEventListener('click',function(){
      var expanded=root.classList.toggle('is-expanded');
      toggle.innerHTML=expanded
        ? 'READ LESS <span aria-hidden="true">←</span>'
        : 'READ MORE <span aria-hidden="true">→</span>';
    });
  }

  function init(){
    each('[data-arshe-notes]',initNotes);
    each('[data-arshe-notes]',initNoteCopy);
    each('[data-arshe-description]',initDescription);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init,{once:true});
  }else{
    init();
  }
})();
